var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9386 18C7.4016 18 6.9442 17.8077 6.5664 17.4231C6.1888 17.0383 6 16.5724 6 16.0255V10.1967C6 9.64978 6.1888 9.18391 6.5664 8.79911C6.9442 8.41452 7.4016 8.22222 7.9386 8.22222H8.8614L10.0614 7H13.9386L15.1386 8.22222H16.0614C16.5984 8.22222 17.0558 8.41452 17.4336 8.79911C17.8112 9.18391 18 9.64978 18 10.1967V16.0255C18 16.5724 17.8112 17.0383 17.4336 17.4231C17.0558 17.8077 16.5984 18 16.0614 18H7.9386ZM7.9386 16.7778H16.0614C16.2768 16.7778 16.4538 16.7073 16.5924 16.5663C16.7308 16.4252 16.8 16.2449 16.8 16.0255V10.1967C16.8 9.97733 16.7308 9.79705 16.5924 9.65589C16.4538 9.51493 16.2768 9.44444 16.0614 9.44444H7.9386C7.7232 9.44444 7.5462 9.51493 7.4076 9.65589C7.2692 9.79705 7.2 9.97733 7.2 10.1967V16.0255C7.2 16.2449 7.2692 16.4252 7.4076 16.5663C7.5462 16.7073 7.7232 16.7778 7.9386 16.7778ZM12 14.8503C12.4754 14.8503 12.8789 14.6816 13.2105 14.344C13.5419 14.0063 13.7076 13.5953 13.7076 13.1111C13.7076 12.6269 13.5419 12.2159 13.2105 11.8782C12.8789 11.5407 12.4754 11.3719 12 11.3719C11.5246 11.3719 11.1211 11.5407 10.7895 11.8782C10.4581 12.2159 10.2924 12.6269 10.2924 13.1111C10.2924 13.5953 10.4581 14.0063 10.7895 14.344C11.1211 14.6816 11.5246 14.8503 12 14.8503Z",
    fill: "#004BA8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.c40b258021d83feac41a4fb82518e8b7.svg";
export { ForwardRef as ReactComponent };